import { render, staticRenderFns } from "./previewPtenEmail.vue?vue&type=template&id=5a973e71&scoped=true"
import script from "./previewPtenEmail.vue?vue&type=script&lang=js"
export * from "./previewPtenEmail.vue?vue&type=script&lang=js"
import style0 from "./previewPtenEmail.vue?vue&type=style&index=0&id=5a973e71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a973e71",
  null
  
)

export default component.exports